import { createAction } from '../../util/';

export const openModal = createAction('OPEN_MODAL');
export const closeModal = createAction('CLOSE_MODAL', { noPayload: true });
export const clearModal = createAction('CLEAR_MODAL', { noPayload: true });

export const disableModal = createAction('DISABLE_MODAL');
export const enableModal = createAction('ENABLE_MODAL');
